import React from 'react'

// Node Modules
import { DomElement } from 'html-react-parser'

// Components
import CASFormat from 'components/xis/CASFormat'

export default ({ attribs }:DomElement) => {
  const format = attribs && attribs['data-xis-cas-lang']
  const file = attribs && attribs['data-xis-resource-name']

  if (!format || !file) {
    return <React.Fragment />
  }
  
  return <CASFormat format={format} file={file} />
}